export default __webpack_public_path__ + "locales/ja-JP/FilesSettings.json?hash=7c1ca2c614ea3f5020426b9b45d0c023";